"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function ExperienceSkeleton() {
  return (
    <div className="flex flex-col">
      <SkeletonBar className="h-[52px] w-full !rounded-t-md !rounded-b-none" />
      <div className="flex gap-4 border-x border-t border-border bg-surface-elevated p-5">
        {[1, 2, 3].map((n) => (
          <SkeletonBar key={n} className="flex-1 h-[75px] !rounded-xl" />
        ))}
      </div>
      {[1, 2].map((n) => (
        <div
          key={n}
          className="flex gap-2.5 border-x border-b border-border bg-surface-elevated p-5 last:rounded-b-md"
        >
          <SkeletonBar className="size-[42px] !rounded-md shrink-0" />
          <div className="flex-1 min-w-0 flex flex-col gap-1.5">
            <SkeletonBar className="h-3.5 w-[120px]" />
            <SkeletonBar className="h-[13px] w-[80%]" />
            <SkeletonBar className="h-[13px] w-[60px]" />
          </div>
        </div>
      ))}
    </div>
  );
}
